import styled from 'styled-components';

export const StyledButton = styled.button<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid ${(props) => (props.$isActive ? 'rgba(7, 114, 229, 1)' : 'rgba(0, 0, 0, 0.12)')};
  background: ${(props) => (props.$isActive ? 'rgba(7, 114, 229, 0.08)' : '#fff')};
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  color: ${(props) => (props.$isActive ? 'rgba(7, 114, 229, 1)' : 'rgba(0, 0, 0, 0.87)')};

  &:hover {
    background: ${(props) => (props.$isActive ? 'rgba(7, 114, 229, 0.12)' : 'rgba(0, 0, 0, 0.04)')};
  }
`;

export const IconWrapper = styled.span<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  color: ${(props) => (props.$isActive ? 'rgba(7, 114, 229, 1)' : 'rgba(0, 0, 0, 0.54)')};
`;

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  min-width: 380px;
  gap: 16px;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
`;

export const StartDateButton = styled.button<{ $hasValue?: boolean; $size?: 'small' | 'medium' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${(props) => (props.$size === 'medium' ? '56px' : '40px')};
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  background: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: ${(props) => (props.$size === 'medium' ? '16px' : '14px')};
  color: ${(props) => (props.$hasValue ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.38)')};

  &:hover {
    border-color: rgba(0, 0, 0, 0.87);
  }
`;
